var _excluded = ["className"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Address from './address';
import * as styles from './allhomes-listing-card-address.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AllhomesListingCardAddress = _ref => {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'allhomes-listing-card__details-address' : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX("div", {
    css: styles.address,
    className: className
  }, ___EmotionJSX(Address, props));
};